import { render, staticRenderFns } from "./CompensationOnProofDetailModal.vue?vue&type=template&id=fa6ea16e&scoped=true"
import script from "./CompensationOnProofDetailModal.vue?vue&type=script&lang=ts"
export * from "./CompensationOnProofDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./CompensationOnProofDetailModal.vue?vue&type=style&index=0&id=fa6ea16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6ea16e",
  null
  
)

export default component.exports